module.exports = __webpack_public_path__ + "static/media/PATS_3-1018w.0678e4d8.webp";